// Clipboard management for element copy/paste functionality

interface ClipboardElement {
    element: UIElement;
    timestamp: number;
}

class ElementClipboard {
    private clipboardData: ClipboardElement | null = null;

    copy(element: UIElement): void {
        // Create a deep copy of the element to avoid reference issues
        const elementCopy: UIElement = {
            ...element,
            id: element.id, // Keep original ID for now, will generate new one on paste
            metadata: { ...element.metadata },
        };

        this.clipboardData = {
            element: elementCopy,
            timestamp: Date.now(),
        };
    }

    paste(): UIElement | null {
        if (!this.clipboardData) {
            return null;
        }

        // Generate a new ID for the pasted element
        const newId = `${this.clipboardData.element.type}-${Date.now()}`;

        return {
            ...this.clipboardData.element,
            id: newId,
            metadata: { ...this.clipboardData.element.metadata },
        };
    }

    canPaste(): boolean {
        return this.clipboardData !== null;
    }

    clear(): void {
        this.clipboardData = null;
    }

    getClipboardInfo(): {
        elementType: UIElementType;
        timestamp: number;
    } | null {
        if (!this.clipboardData) {
            return null;
        }

        return {
            elementType: this.clipboardData.element.type,
            timestamp: this.clipboardData.timestamp,
        };
    }
}

// Export a singleton instance
export const elementClipboard = new ElementClipboard();
